import React from "react";

const brands = [
  { name: "Samsung", color: "#1428A0" },
  { name: "LG", color: "#A50034" },
  { name: "Sony", color: "#000000" },
  { name: "Mi", color: "#FF6700" },
  { name: "OnePlus", color: "#EB0028" },
  { name: "TCL", color: "#003DA5" },
  { name: "Panasonic", color: "#0F58A0" },
  { name: "Philips", color: "#0B5ED7" },
  { name: "Toshiba", color: "#FF0000" },
  { name: "Whirlpool", color: "#1E4D8C" },
  { name: "Bosch", color: "#E30613" },
  { name: "IFB", color: "#004B87" },
  { name: "Godrej", color: "#5C2D91" },
  { name: "Haier", color: "#C8102E" },
  { name: "Vu", color: "#F4A900" },
];

const BrandLogo = ({ name, color }) => (
  <div className="brand-logo-item" aria-label={`${name} repair service available`}>
    <span className="brand-logo-text" style={{ color }}>
      {name}
    </span>
  </div>
);

const BrandsSection = () => {
  return (
    <section id="brands-section" className="section brands-section" aria-label="Brands we service">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-label">Trusted Expertise</div>
          <h2 className="section-title">Brands We Service</h2>
          <p className="section-subtitle">
            We are certified to repair and service all major TV and washing machine brands. Your device is in expert hands.
          </p>
        </div>

        <div className="brands-marquee-wrapper">
          <div className="brands-marquee-fade brands-marquee-fade-left" />
          <div className="brands-marquee-fade brands-marquee-fade-right" />
          <div className="brands-marquee">
            <div className="brands-marquee-track">
              {/* First set */}
              {brands.map((brand, index) => (
                <BrandLogo key={`a-${index}`} name={brand.name} color={brand.color} />
              ))}
              {/* Duplicate for seamless loop */}
              {brands.map((brand, index) => (
                <BrandLogo key={`b-${index}`} name={brand.name} color={brand.color} />
              ))}
            </div>
          </div>
        </div>

        {/* Brand count badge */}
        <div className="brands-badge-row">
          <div className="brands-badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span>15+ Brands Serviced</span>
          </div>
          <div className="brands-badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
            <span>TVs & Washing Machines</span>
          </div>
          <div className="brands-badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <span>Genuine Parts Only</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
